import styled from "styled-components";

export const Wrapper = styled.section`
font-size:16px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: left;
color: black;
object-fit: contain;
margin-bottom:40px;
font-family: Arial;

label {
    display:block;
}

@media (max-width:767px){
  font-size: 12px;
}
`

export const SectionCardHeading = styled.div`
font-size: 24px;
    text-align: left;
    @media (max-width: 768px) {
      font-size: 20px;
    }
`

export const CustomLabel = styled.label`
font-size:${(props => props.font_size ? props.font_size : "16")}px;
font-weight:${(props => props.font_weight ? props.font_weight : "bold")};
color:${props => props.color ? props.color : "black"};
@media (max-width:767px) {
  font-size:${(props => props.font_size ? (props.font_size-3) : "12")}px;
}
`

export const CustomList = styled.li`
font-size:${(props => props.font_size ? props.font_size : "16")}px;
font-weight:${(props => props.font_weight ? props.font_weight : "bold")};
`

export const SectionCardDark = styled.div`
  width: 100%;
  height: auto;
  padding: 33px 40px;
  border-radius: 10px;
  background-color: #f2f2f2;
  @media (max-width: 768px) {
    padding: 19px 20px;
  }
`
export const BookAppointmentButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  width: 215px;
  height: 50px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
  }
  .ant-btn-text {
    color: white !important;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
    }
  }
  @media (max-width:768px){
    width: 165px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
  }
`;

export const BookAppointmentSmallButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 35px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
  }
  .ant-btn-text {
    color: white !important;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
    }
  }
  @media (max-width:768px){
    width: 165px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
  }
`;
export const SubmitHealthButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 40px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
  }
  .ant-btn-text {
    color: white !important;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
    }
  }
  @media (max-width:768px){
    width: 165px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
  }
`;
export const BookOutlinedButton = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 170px;
height: 40px;
border-radius: 40px;
border: solid 2px #f47720;
margin-top: 10px;
margin-right: 20px;
text-align: center;
.ant-btn-text[disabled] {
  color: #f26221 !important;
  font-weight: normal;
}
.ant-btn-text {
  color: #f47720 !important;
  font-weight: normal;
}
&:hover {
  .ant-btn-text[disabled] {
    color: #f47720 !important;
    font-weight: normal;
  }
}
@media (max-width: 768px) {
  width: 140px;
  height: 35px;
  border-radius: 17.5px;
  padding: 12px 2px;
  .ant-btn-text[disabled] {
    font-size: 11px;
  }
  .ant-btn-text {
    font-size: 11px;
  }
`;

export const AcceptOfferButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 38px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
  }
  .ant-btn-text {
    color: white !important;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
    }
  }
  @media (max-width:768px){
    width: 165px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
  }
`;